import React, { useState, useEffect, useMemo, useCallback } from 'react';

import Spin from 'antd/es/spin';

import PredictionsSettingsService from 'services/predictionsSettings';

import { Title } from 'components/Text';
import { Row, Col } from 'components/layout';
import Button from 'components/Button';

import SettingsList from '../components/SettingsList';

const targetTimeSettingsSchema = [
  {
    name: 'target_time_buffer',
    inputType: 'percentage',
    title: 'Target Time Buffer Percentage',
    description: 'Change will be reflected on the upcoming processes',
    min: 0,
    max: 100,
  },
  {
    name: 'target_time_buffer_forklift',
    inputType: 'percentage',
    title: 'Target Time Buffer Percentage for Processes with Forklift',
    description: 'Change will be reflected on the upcoming processes',
    min: 0,
    max: 100,
  },
];

const predictionsSettingsService = new PredictionsSettingsService();

const TargetTimeTab = ({ showMessage }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [settingsValues, setSettingsValues] = useState([]);

  const modifiedSettingsValues = useMemo(() => {
    return settingsValues.filter(settingValue => !!settingValue.modified);
  }, [settingsValues]);

  useEffect(() => {
    setIsLoading(true);
    predictionsSettingsService.getPredictionsBuffers().then(data => {
      if (!data) return;

      const targetTimeBuffer = data.find(value => value.unload_method === 'normal');
      const targetTimeBufferForklift = data.find(value => value.unload_method === 'forklift');

      setSettingsValues([
        {
          id: targetTimeBuffer.id,
          name: 'target_time_buffer',
          value: targetTimeBuffer.buffer_val,
          modified: false,
        },
        {
          id: targetTimeBufferForklift.id,
          name: 'target_time_buffer_forklift',
          value: targetTimeBufferForklift.buffer_val,
          modified: false,
        }
      ]);
    })
    .finally(() => {
      setIsLoading(false);
    });
  }, []);

  const onSaveChanges = useCallback(() => {
    setIsSubmitting(true);

    const updates = modifiedSettingsValues.map(settingValue => {
        return {
          id: settingValue.id,
          buffer_val: settingValue.value,
        };
    }, []);

    predictionsSettingsService.updatePredictionsBuffers({
      Values: updates,
    }).then(() => {
      showMessage('success', 'Target Time settings updated');
      setSettingsValues(settingsValues => settingsValues.map(config => {
        config.modified = false;
        return config;
      }));
    })
    .catch(() => {
      showMessage('error', 'Failed to save Target Time settings');
    })
    .finally(() => {
      setIsSubmitting(false);
    });
  }, [showMessage, modifiedSettingsValues]);

  if (isLoading) {
    return (
      <Spin
        size={30}
        style={{ width: '100%', padding: '36px' }}
      />
    );
  }

  return (
    <Row justify="center">
      <Col span={18}>
        <Title
          level={4}
          style={{
            textAlign: 'center',
            marginBottom: '32px'
          }}
        >
          Target Time
        </Title>
        <SettingsList
          settingsSchema={targetTimeSettingsSchema}
          settingsValues={settingsValues}
          setSettingsValues={setSettingsValues}
        />
        <Row justify="center" style={{ padding: '16px 0' }}>
          <Button
            type="primary"
            loading={isSubmitting}
            disabled={modifiedSettingsValues.length === 0}
            size="large"
            onClick={onSaveChanges}
            style={{
              width: '350px'
            }}
          >
            Save Changes
          </Button>
        </Row>

      </Col>
    </Row>
  );
};

export default TargetTimeTab;
